import React, {Fragment, useEffect, useState} from 'react';
import Validator from 'components/validator';
import Dropdown from 'components/dropdown';
import Select from 'components/form/select-input';

function Field(props) {
    return (
        <div className="field" disabled={true}>
            <div className="field-label">
                <label className="label">{props.label}</label>
            </div>
            <div className="field-input">{props.input}</div>
        </div>
    );
}

export function Username(props) {
    const {strings, autocomplete, form} = props;
    const [readOnly, setReadOnly] = useState(autocomplete === 'off')

    const onFocus = () => {
        setReadOnly(false);
    }

    return (
        <Field
            label={strings['page.lives.view.add_stream.username']}
            input={
                <input
                    type="text"
                    className="input"
                    name="username"
                    value={form.username}
                    {...(autocomplete === 'off' ? {
                        readOnly,
                        onFocus } : null)
                    }
                    />
            }
        />
    );
}

export function Password(props) {
    const {strings, form, autocomplete, onValidateForm} = props;
    const [readOnly, setReadOnly] = useState(autocomplete === 'off')

    const onFocus = () => {
        setReadOnly(false);
    }

    return (
        <Fragment>
            <Field
                label={strings['page.lives.view.add_stream.password']}
                input={
                    <input
                        type="password"
                        className="input"
                        name="password"
                        value={form.password}
                        {...(autocomplete === 'off' ? {
                            readOnly,
                            onFocus } : null)
                        }
                    />
                }
            />
            <Field
                label={strings['page.lives.view.add_stream.confirm']}
                input={
                    <Validator
                        value={form.confirm || 'empty'}
                        onValidateForm={onValidateForm}
                        validators={[{name: 'confirm', params: form.password}]}
                        render={({hasError, messages, value}) => (
                            <input
                                type="password"
                                className={`input ${hasError ? '_error' : ''}`}
                                name="confirm"
                                value={form.confirm}
                            />
                        )}
                    />
                }
            />
        </Fragment>
    );
}

export function Provider(props) {
    const {strings, form, onValidateForm, providers} = props;
    
    return (
        <Field
            label={strings['page.lives.view.add_stream.provider']}
            input={
                <Validator
                    value={form.provider}
                    onValidateForm={onValidateForm}
                    validators={['isRequired']}
                    render={({hasError, messages, value}) => (
                        <Dropdown
                            name="provider"
                            value={value}
                            items={providers}
                            headerModificator="big"
                        />
                    )}
                />
            }
        />
    );
}

export function StreamKey(props) {
    const {form, strings, onValidateForm, streamHelp} = props;

    return (
        <Field
            label={strings['page.lives.view.add_stream.stream_key']}
            input={
                <Fragment>
                    <Validator
                        value={form.key}
                        onValidateForm={onValidateForm}
                        validators={['isRequired']}
                        render={({hasError, messages, value}) => (
                            <input
                                type="text"
                                className={`input ${hasError ? '_error' : ''}`}
                                name="key"
                                value={value}
                                onChange={() => {}}
                            />

                        )}
                    />
                    {streamHelp}
                </Fragment>
            }
        />
    );
}

export function BackupUrl(props) {
    const {form, strings, onValidateForm} = props;

    return (
        <Field
            label={strings['page.lives.view.add_stream.backup_url']}
            input={
                <Validator
                    value={form.backup_url}
                    onValidateForm={onValidateForm}
                    validators={['isRtmpURL']}
                    render={({hasError, messages, value}) => (
                        <input
                            type="text"
                            className={`input ${hasError ? '_error' : ''}`}
                            name="backup_url"
                            value={value}
                        />
                    )}
                />
            }
        />
    );
}

export function IPAddress(props) {
    const {form, strings, onValidateForm} = props;
    return (
        <Field
            label={strings['page.lives.view.add_stream.ip_address']}
            input={
                <Validator
                    value={form.hls_target_ip_address}
                    onValidateForm={onValidateForm}
                    validators={['isIP']}
                    render={({hasError, messages, value}) => (
                        <Fragment>
                            <input
                                type="text"
                                className={`input ${hasError ? '_error' : ''}`}
                                name="hls_target_ip_address"
                                value={value}
                                placeholder='Optional'
                            />
                            {hasError && (<div className="error">{messages[0]}</div>)}
                        </Fragment>
                    )}
                />
            }
        />
    );
}

export function PrimaryUrl(props) {
    const {form, strings, onValidateForm, onChange, onBlur} = props;

    return (
        <Field
            label={strings['page.lives.view.add_stream.primary_rtmp_url']}
            input={
                <Validator
                    value={form.primary_url}
                    onValidateForm={onValidateForm}
                    validators={[
                        'isRequired',
                        'isRtmpURL'
                    ]}
                    render={({hasError, messages, value}) => (
                        <Fragment>
                            <input
                                type="text"
                                className={`input ${hasError ? '_error' : ''}`}
                                name="primary_url"
                                value={value}
                                onChange={onChange}
                                onBlur={onBlur}
                            />
                            {hasError && (<div className="error">{messages[0]}</div>)}
                        </Fragment>
                    )}
                />
            }
        />
    );
}

export function PrimarySRTUrl(props) {
    const {form, strings, onValidateForm} = props;
    return (
        <Field
            label={strings['page.lives.view.add_stream.primary_url']}
            input={
                <Validator
                    value={form.primary_url}
                    onValidateForm={onValidateForm}
                    validators={[
                        'isRequired',
                        'isSrtURL'
                    ]}
                    render={({hasError, messages, value}) => (
                        <Fragment>
                            <input
                                type="text"
                                className={`input ${hasError ? '_error' : ''}`}
                                name="primary_url"
                                value={value}
                            />
                            {hasError && (<div className="error">{messages[0]}</div>)}
                        </Fragment>
                    )}
                />
            }
        />
    );
}

